import { render, staticRenderFns } from "./CropTypeAndVarietySetting.vue?vue&type=template&id=1836d377&scoped=true"
import script from "./CropTypeAndVarietySetting.vue?vue&type=script&lang=js"
export * from "./CropTypeAndVarietySetting.vue?vue&type=script&lang=js"
import style0 from "./CropTypeAndVarietySetting.vue?vue&type=style&index=0&id=1836d377&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1836d377",
  null
  
)

export default component.exports